<template>
  <div style="position:relative">
    <div class="butt">
      <a-button type="primary" @click="submit" v-if="$auth('role.equipmentClassification')">保存</a-button>
      <a-button style="margin:0 10px" @click="reset">重置</a-button>
    </div>
    <a-spin :spinning="loading">
      <div ref="box" style="height:100%;overflow:auto;">
        <a-tree
          ref="tree"
          v-model="checkedKeys"
          :autoExpandParent="autoExpandParent"
          :expandedKeys="expandedKeys"
          :treeData="treeData"
          checkable
          @check="onCheck"
          @expand="onExpand"
        >
          <template slot="custom" slot-scope="record">
            <span class="title-name">{{ record.name }}</span>
          </template>
        </a-tree>
      </div>
    </a-spin>

  </div>
</template>

<script>
import { getEquipmentTypePermission, setEquipmentTypePermission } from '@/api/roleList.js'
import { getDeviceTypeTree } from '@/api/deviceType'

export default {
  async mounted () {
    await this.initTree()
    await this.getPermissionData()
  },
  data () {
    return {
      treeData: [],
      checkedKeys: [],
      expandedKeys: [],
      loading: false,
      autoExpandParent: true
    }
  },
  computed: {
    roleId () {
      return this.$store.state.role.roleId
    },
    roleName () {
      return this.$store.state.role.roleName
    }
  },
  watch: {
    roleId (id) {
      this.$nextTick(() => {
        this.$refs.box.scrollTop = 0
      })
      this.getPermissionData()
    }
  },
  methods: {
    // 树结构
    async initTree () {
      this.loading = true
      const res = await getDeviceTypeTree()
      if (res && res.status === 0) {
        const loop = data => {
          for (let i = 0; i < data.length; i++) {
            const item = data[i]
            // do
            item.key = item.code
            item.scopedSlots = {
              title: 'custom'
            }
            if (item.children && item.children.length > 0) {
              loop(item.children)
            }
          }
        }
        loop(res.data)
        this.treeData = res.data
      }
      this.loading = false
    },
    // 对应人员部门权限数据
    async getPermissionData () {
      this.loading = true
      const params = { roleId: this.roleId }
      const res = await getEquipmentTypePermission(params)
      if (res && res.status === 0) {
        this.checkedKeys = res.data.map(item => item.typeCode ? item.typeCode : item.code)
        this.expandedKeys = this.getExpandedKeys()
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    // 提交
    async submit () {
      const equipmentTypes = []
      this.checkedKeys.forEach(item => {
        if (item.indexOf('父') === -1) {
          equipmentTypes.push({
            typeCode: item
          })
        }
      })
      const params = {
        roleId: this.roleId,
        equipmentTypes: equipmentTypes
      }
      const res = await setEquipmentTypePermission(params)
      if (res && res.status === 0) {
        this.$message.success(res.info.message)
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    reset () {
      this.getPermissionData()
    },
    // dfs 由选中数组得展开数组
    getExpandedKeys () {
      let arr = []
      const stack = []
      const loop = data => {
        for (let i = 0; i < data.length; i++) {
          const item = data[i]
          // do
          if (this.checkedKeys.indexOf(item.key) !== -1) {
            arr = [...arr, ...stack]
          }
          stack.push(item.key)
          if (item.children && item.children.length) {
            loop(item.children)
          }
          stack.pop()
        }
      }
      loop(this.treeData)
      return Array.from(new Set(arr))
    },
    onCheck (checkedKeys, e) {
      this.checkedKeys = checkedKeys
    },
    onExpand (expandedKeys, option) {
      this.expandedKeys = expandedKeys
      this.autoExpandParent = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/ .ant-tree.ant-tree-icon-hide {
  overflow-y: visible !important;
}
.butt {
  display:flex;
  position: absolute;
  top: 4px;
  left: 480px;

  // position: fixed;
  // top: 165px;
  // left: 800px;
  z-index: 100;
}
</style>
